import {SET_WIDTH} from './types'

export function setWidth(width) {
	return {
		type: SET_WIDTH,
		width
	}
}